import UserProfileAdd2 from 'blaze-ui/icons/20/UserProfileAdd2'
import { InitiateOauthTrigger } from 'components/ConnectIntegrationTrigger/InitiateOauthTrigger'
import { ConnectedIntegration } from 'components/Onboarding/Integration/ConnectedIntegration'
import { ProviderToConnectText } from 'screens/blaze/Home/VirtualMarketerHome/Performance/ConnectIntegrationRow'
import { Button } from 'blaze-ui/Button'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { isSocialMediaIntegration } from 'components/TacticIntegrationList/utils'
import Styles from './ChannelIntegrationButton.module.scss'
import { ConnectedIntegrationsButton } from './ConnectedIntegrationsButton'
import client from 'api/client'
import { useAccountLimitStatus } from 'hooks/useAccountLimitStatus'

interface ChannelIntegrationButtonProps {
  integrations?: ExternalIntegration[]
  isHovered: boolean
  provider?: ExternalIntegrationEnum
  isDisabled?: boolean
  showDisabledLabel?: boolean
}

export const ChannelIntegrationButton = ({
  integrations = [],
  isHovered,
  provider,
  isDisabled,
  showDisabledLabel = false,
}: ChannelIntegrationButtonProps) => {
  const { connect } = useConnectAccountPopup()
  const integration = integrations[0] || null
  const hasIntegrations = integrations.length > 0
  const { isAtOrAboveMaxAccounts } = useAccountLimitStatus()

  if (!provider) {
    if (!isHovered) return null

    return (
      <Button frontIcon={UserProfileAdd2} variant="secondary" size="md" isDisabled>
        Coming Soon
      </Button>
    )
  }

  if (isHovered && (!hasIntegrations || (hasIntegrations && isDisabled))) {
    let buttonText = `Connect ${ProviderToConnectText[provider]}`
    if (isDisabled && showDisabledLabel) {
      buttonText = 'To enable this channel, remove another first'
    } else if (isAtOrAboveMaxAccounts) {
      buttonText = `Connect ${ProviderToConnectText[provider]} (extra $10/month)`
    } else {
      buttonText = `Connect ${ProviderToConnectText[provider]}`
    }

    return (
      <InitiateOauthTrigger provider={provider} popUp onInitiatedOauth={connect}>
        <Button
          frontIcon={UserProfileAdd2}
          variant="secondary"
          size="md"
          isDisabled={isDisabled}
          aria-label={buttonText}
        >
          {buttonText}
        </Button>
      </InitiateOauthTrigger>
    )
  }

  const showMultipleAccounts = isSocialMediaIntegration(provider)

  if (hasIntegrations && !isDisabled) {
    return (
      <div className={Styles.connectedButtonContainer}>
        {showMultipleAccounts && isHovered && (
          <InitiateOauthTrigger
            provider={provider}
            popUp
            onInitiatedOauth={(popup?: Window) => {
              connect(popup, {
                isAdditionalAccount: true,
                onConnect: () => {
                  client.trackEvent('Event::ExtraAccountAddedOnTrial', { variant: 'onboarding' })
                },
              })
            }}
          >
            <Button frontIcon={UserProfileAdd2} variant="secondary" size="md" isDisabled={isDisabled}>
              {!isAtOrAboveMaxAccounts ? 'Add Extra Account' : 'Add Extra Account for $10/month'}
            </Button>
          </InitiateOauthTrigger>
        )}
        {showMultipleAccounts ? (
          <ConnectedIntegrationsButton integrations={integrations} />
        ) : (
          <ConnectedIntegration integration={integration} showDisconnectButton={false} />
        )}
      </div>
    )
  }

  return null
}
